// Casca das telas logadas: sidebar (desktop) / drawer (mobile) + área de
// conteúdo. Navegação declarada como dado. Design próprio do UEB — ícones em
// "chips" que acendem no item ativo + barra indicadora na lateral.
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import {
    LayoutDashboard, ShoppingBag, IdCard, ReceiptText, Truck,
    GraduationCap, LogOut, Menu, X,
} from 'lucide-react';
import ThemeToggle from './ThemeToggle';
import { getUser, logout } from '../auth/storage';

const NAV = [
    { path: '/', label: 'Início', Icon: LayoutDashboard },
    { path: '/produtos', label: 'Produtos', Icon: ShoppingBag },
    { path: '/minha-carteirinha', label: 'Minha carteirinha', Icon: IdCard },
    { path: '/meu-historico', label: 'Histórico', Icon: ReceiptText },
    { path: '/rastreamento', label: 'Rastreamento', Icon: Truck },
    { path: '/funemg', label: 'FUNEMG EAD', Icon: GraduationCap },
];

// Marca do UEB: só a logo do /public (ueblogo.png), que já traz o nome.
function BrandUEB() {
    return (
        <div className="ueb-shell-brand">
            <Link to="/" aria-label="Voltar ao início">
                <img className="ueb-shell-brand-logo" src="ueblogo.png" alt="UEB — Carteirinha de Estudante" />
            </Link>
        </div>
    );
}

export default function AppShell({ children }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const user = getUser();
    const nome = user?.nome || user?.nome_completo || user?.name || 'Estudante';

    useEffect(() => { setOpen(false); }, [location.pathname]);

    // Logout: limpa a sessão e faz uma navegação REAL pra "/" (não o navigate do
    // router). Como o Início já mora em "/", um navigate('/') não remontaria a
    // Home e a sessão não seria reavaliada — a tela ficaria como se não saísse.
    // O reload garante cair na Landing e zera todo o estado em memória.
    const sair = () => { logout(); window.location.assign('/'); };

    return (
        <div className="ueb-shell">
            <button className="ueb-shell-burger" onClick={() => setOpen(true)} aria-label="Abrir menu">
                <Menu size={22} />
            </button>

            {open && <div className="ueb-shell-backdrop" onClick={() => setOpen(false)} />}

            <aside className={`ueb-shell-side ${open ? 'is-open' : ''}`}>
                <div className="ueb-shell-side-head">
                    <BrandUEB />
                    <button className="ueb-shell-close" onClick={() => setOpen(false)} aria-label="Fechar menu">
                        <X size={20} />
                    </button>
                </div>

                <span className="ueb-shell-navlabel">Navegação</span>
                <nav className="ueb-shell-nav">
                    {NAV.map(({ path, label, Icon }) => {
                        const ativo = location.pathname === path;
                        return (
                            <button
                                key={path}
                                className={`ueb-shell-link ${ativo ? 'is-active' : ''}`}
                                onClick={() => navigate(path)}
                            >
                                <Icon className="ueb-shell-link-ico" size={19} />
                                <span className="ueb-shell-link-txt">{label}</span>
                                {ativo && <span className="ueb-shell-link-dot" aria-hidden="true" />}
                            </button>
                        );
                    })}
                </nav>

                <div className="ueb-shell-side-foot">
                    <ThemeToggle withLabel />
                    <div className="ueb-shell-user">
                        <div className="ueb-shell-avatar">{String(nome).charAt(0).toUpperCase()}</div>
                        <div className="ueb-shell-user-info">
                            <strong title={nome}>{nome}</strong>
                            <span>Estudante</span>
                        </div>
                        <button className="ueb-shell-logout" onClick={sair} aria-label="Sair" title="Sair">
                            <LogOut size={17} />
                        </button>
                    </div>
                </div>
            </aside>

            <main className="ueb-shell-main">
                <div className="ueb-shell-main-inner">
                    {children}
                </div>
            </main>
        </div>
    );
}
